//src/pages/landing/LandingPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateProjectCodes } from "../../api/project/projectApi";
// import logo from "../.././assets/images/myassessment.ai_logo.png";
import landingimg from "../.././assets/images/AI_Hero.jpg";
import { FaArrowRight, FaArrowRightLong } from "react-icons/fa6";
import cloud from "../../assets/images/upload_cloud.png";
import wand from "../../assets/images/magic_wand.png";
import send from "../../assets/images/send.png";
import data from "../../assets/images/cloud_data.png";
// import herogif from "../../assets/images/hero_gif.gif";
import feature_1 from "../../assets/images/feature_1.jpg";
import feature_2 from "../../assets/images/feature_2.jpg";
import feature_3 from "../../assets/images/feature_3.jpg";
import feature_4 from "../../assets/images/feature_4.jpg";
import feature_5 from "../../assets/images/feature_5.jpg";
import feature_6 from "../../assets/images/feature_6.png";
import TermsAndPolicyFooter from "../../components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyFooter";
import BookDemoModal from "./BookDemoModal";
import overlayVid from "../../assets/annimations/download.mp4";

const LandingPage = () => {
  const [projectCode, setProjectCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showDemoModal, setShowDemoModal] = useState(false);
  const navigate = useNavigate();

  const steps = [
    {
      title: "Upload Topics",
      description:
        "Drop in your syllabus or learning objectives/materials in any format.",
      icon: cloud,
    },
    {
      title: "AI Generates Questions",
      description:
        "MCQ’s , subjective and conversation question appear instantly.",
      icon: wand,
    },
    {
      title: "Share Code",
      description:
        "Give participants the code, watch leaderboards update live.",
      icon: send,
    },
    {
      title: "Track Reports",
      description:
      "Monitor every submission, score and leaderboards the moment it happens, giving you instant, actionable insight.",
      icon: data,
    },
  ];

  const cardData = [
    {
      category: "Auto-Graded MCQs & Subjectives",
      image: feature_1,
      description:
        "Instant scoring for objective and written answers—no spreadsheets, no manual checking.",
    },
    {
      category: "AI Powered Questions",
      image: feature_2,
      description:
        "Questions get generated by AI based on the uploaded material/content.",
    },
    {
      category: "Conversational AI Scoring ",
      image: feature_3,
      description:
        "Evaluate skills with on the spot question generation and scoring.",
    },
    {
      category: "Real -Time Results",
      image: feature_4,
      description:
        "Motivate participants and spot trends with dynamic rankings that update as tests finish.",
    },
    {
      category: "Cohort Analytics",
      image: feature_5,
      description:
        "Track each participants pre and post test gains and percentile rank versus cohort.",
    },
    {
      category: "PDF / CSV Exports",
      image: feature_6,
      description:
        "One-click downloads for reports, certificates, and raw data.",
    },
  ];

  const items = [
    "AI-Generated or Custom Questionnaires",
    "Real-Time Results Dashboard",
    "Lightning-Fast Assessment Workflow",
    "Live Leaderboards for facilitators and participants",
    "Clean, Intuitive Answer Sheets",
    "Instant Certificate Issuance",
    "Actionable Results Analytics",
  ];

  const validateProjectCode = async (code = projectCode) => {
    try {
      const response = await validateProjectCodes(code);
      //console.log('Project Code being sent:', projectCode);
      const { status, message, project_id } = response.data;

      if (status) {
        navigate("/learner-details", {
          state: { projectId: project_id, projectCode: code },
        });
        //console.log('Navigating with Project ID:', response.data.project_id);
      } else {
        setErrorMessage(message);
      }
    } catch (error) {
      console.error("Error validating project code:", error);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  const loginHandler = () => {
    navigate("/login_register");
  };

  return (
    <div className="flex flex-col items-center w-full min-h-screen pt-4 overflow-x-hidden">
      {/* <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#1e3a8a] via-[#6d28d9] to-[#9333ea] p-4"> */}

  <div className="w-full max-w-6xl rounded-3xl overflow-hidden shadow-2xl grid md:grid-cols-2">
    <div className="relative bg-gradient-to-l from-indigo-950 to-indigo-800 flex items-center justify-center p-10">
      <div className="absolute w-72 h-72 bg-cyan-300 opacity-30 blur-3xl rounded-full"></div>

      <img
        src={landingimg}
        alt="AI Illustration"
        className="relative z-10 w-[80%] drop-shadow-2xl"
      />

    </div>


    <div className="bg-white p-10 flex flex-col justify-center text-center">


      <h2 className="text-2xl md:text-3xl font-extrabold text-[#36369f]">
        🚀 Start Your AI Assessment
      </h2>

      <p className="text-gray-500 mt-2 mb-6">
        Enter your code to begin your smart evaluation
      </p>

      
      <div className="relative mb-4">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
          
        </span>

        <input
          type="text"
          placeholder="Enter your Assessment Code"
          value={projectCode}
          onChange={(e) => setProjectCode(e.target.value)}
          className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 shadow-sm 
          focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
      </div>

      {errorMessage && (
        <p className="text-red-500 mb-3">{errorMessage}</p>
      )}

      <div className="flex flex-col sm:flex-row gap-3">
      <button
        onClick={() => validateProjectCode()}
        className="flex-1 py-3 rounded-xl text-white font-semibold 
        bg-gradient-to-l from-indigo-950 to-indigo-800
        hover:scale-105 transition-all duration-300"
      >
        Submit
      </button>
      
        <button
          onClick={() => navigate("/explore-assessments")}
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-semibold
          text-[#36369f] border-2 border-indigo-800 bg-white
          hover:bg-indigo-50 hover:scale-105 transition-all duration-300"
        >
          Explore Assessments <FaArrowRight />
        </button>
        </div>

      <div className="flex justify-center gap-4 mt-5 text-sm text-gray-500">
        <span>🔒 Secure</span>
        <span>⚡ Instant</span>
        <span>🤖 AI Powered</span>
      </div>

    </div>

  </div>

{/* </div> */}



  <div className="relative w-full py-16 md:py-24 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-11/12 md:w-9/12 mx-auto">


    <p className="text-3xl md:text-5xl font-extrabold text-center bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
      Welcome to the Future of Assessment
    </p>

    <p className="text-xs md:text-sm mt-3 px-6 py-2 w-fit text-center rounded-full text-gray-600 mx-auto bg-white/60 backdrop-blur-md shadow">
      Built for ease, speed, and results.
    </p>


    <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10 pt-16">


      <div className="text-center md:text-left space-y-6">

        <h2 className="text-3xl md:text-5xl font-extrabold leading-tight">
          Create <span className="text-transparent bg-clip-text bg-gradient-to-l from-indigo-950 to-indigo-800">AI-Driven</span> <br />
          Assessments in Minutes
        </h2>

        <p className="text-base md:text-lg text-gray-600">
          Generate questions, share a code, and watch real-time results —  
          <span className="text-[#36369f] font-semibold"> no manual grading required</span>
        </p>

        <button className="relative overflow-hidden bg-gradient-to-l from-indigo-950 to-indigo-800
        text-white font-semibold px-8 md:px-12 py-3 rounded-xl 
        shadow-lg hover:scale-105 transition-all duration-300 animate-pulseGlow">
          Register & Get Free 3000 Assessments 
        </button>

      </div>

      <div className="flex flex-col items-center gap-6">

        <div className="relative w-full md:w-[520px] h-[200px] md:h-[260px]">

          <div className="absolute inset-0 bg-white opacity-20 blur-2xl rounded-full animate-float"></div>

          {/* <dotlottie-wc
            aria-label="AI animation"
            src="https://lottie.host/f338f711-c0e1-46e8-a2a7-01984fce6fe0/hSN0tfxgUx.lottie"
            background="transparent"
            speed="1"
            class="w-full h-full relative z-10"
            loop
            autoplay
          ></dotlottie-wc> */}

          
          <video
  src={overlayVid}
  autoPlay
  loop
  muted
  playsInline
  className="absolute inset-0 w-full h-full object-contain z-20"
/>

        </div>

        <button
          onClick={() => setShowDemoModal(true)}
          className="flex items-center gap-4 bg-white/80 backdrop-blur-md border border-purple-300 px-6 py-3 rounded-xl shadow 
          hover:shadow-lg hover:scale-105 transition-all duration-300"
        >
          <FaArrowRightLong className="text-xl text-purple-600" />
          <span className="text-sm md:text-base font-semibold text-gray-700">
            Book a Live Demo
          </span>
        </button>

      </div>

    </div>
  </div>
</div>
      
      
<div className="relative w-full py-16 md:py-24 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-11/12 sm:w-10/12 md:w-9/12 mx-auto">


    <div className="text-center mb-12">
      <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        How it works
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
      bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Start Seamlessly with Just 4 Steps
      </h3>

      <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
        Simplify the creation, interaction, analysis and reporting — all in one place.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 items-stretch">

      {steps.map((step, index) => (
        <div key={index} className="group relative h-full">

       
          <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-blue-400 
          opacity-0 group-hover:opacity-20 blur-xl rounded-2xl transition-all duration-300"></div>

      
          <div className="relative flex flex-col justify-between h-full min-h-[200px]  bg-white/70 backdrop-blur-lg border border-white/30 
          rounded-2xl p-6 shadow-md  hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

            
            <div className="absolute -top-3 left-4 px-4 py-1 text-xs font-semibold 
            bg-gradient-to-r from-purple-600 to-blue-500 text-white rounded-full shadow">
              Step {index + 1}
            </div>

          
            <div className="flex items-start gap-4 mt-4">

            
              <div className="flex-shrink-0">
                <img
                  src={step.icon}
                  alt={step.title}
                  className="w-12 h-12 md:w-14 md:h-14 group-hover:scale-110 transition"
                />
              </div>

             
              <div className="flex flex-col">
                <p className="text-lg font-bold mb-1">{step.title}</p>
                <p className="text-sm text-gray-600">{step.description}</p>
              </div>

            </div>

          </div>
        </div>
      ))}

    </div>

  </div>
</div>
      
<div className="relative w-full py-16 md:py-24 overflow-hidden">

  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-11/12 sm:w-10/12 md:w-9/12 mx-auto">

   
    <div className="text-center mb-12">
      <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        Built for You
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
      bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        What's in the Hood for you
      </h3>

      <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
        From intelligent automation to actionable insights — explore features
        that accelerate every step of your process.
      </p>
    </div>

    
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">

      {cardData.map((card, index) => (
        <div key={index} className="group relative h-full">

        
          <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-blue-400 opacity-0 group-hover:opacity-20 blur-xl rounded-2xl transition-all duration-300"></div>

        
          <div className="relative flex flex-col h-full min-h-[380px]  bg-white/70 backdrop-blur-lg border border-white/30 
          rounded-2xl p-5 shadow-md hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

          
            <div className="overflow-hidden rounded-xl">
              <img
                src={card.image}
                alt={card.category}
                className="w-full h-48 object-cover rounded-xl 
                group-hover:scale-105 transition duration-300"
              />
            </div>

            <div className="flex flex-col justify-between flex-1 pt-4">

              <p className="text-lg font-bold text-gray-800 mb-2">
                {card.category}
              </p>

              <p className="text-sm md:text-base text-gray-600 leading-snug">
                {card.description}
              </p>

            </div>

          </div>
        </div>
      ))}

    </div>

  </div>
</div>

     
   
<div className="relative w-full py-16 md:py-20 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-11/12 sm:w-10/12 md:w-9/12 mx-auto text-center">

  
    <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
    bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
      Why It Matters
    </p>


    <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
   bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
      Benefits that go beyond Features
    </h3>


    <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed mt-2">
      From saving time to improving accuracy, Myassessment.ai delivers
      practical advantages that help you work better — 
      <span className="font-semibold text-[#36369f]"> not just harder.</span>
    </p>

  </div>
</div>
 
<>
  <style>
    {`
      @keyframes marquee {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `}
  </style>

  <div className="relative w-full py-6 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-l from-indigo-950 to-indigo-800 opacity-90"></div>

    <div className="relative w-full overflow-hidden">
      <div
        className="flex items-center w-[200%]"
        style={{ animation: "marquee 25s linear infinite" }}
      >
        {[...items, ...items].map((item, index) => (
          <div key={index} className="flex items-center px-10 shrink-0">
            <span className="text-white text-sm md:text-base font-medium">
              ✨ {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>

  <section className="relative w-full py-16">
    <div className="w-11/12 sm:w-10/12 md:w-9/12 mx-auto">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-6 bg-white/70 backdrop-blur-lg border border-white/30 
           rounded-2xl px-8 py-8 shadow-md">

        <h1 className="text-2xl md:text-3xl font-extrabold text-center lg:text-left bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
          Ready to Elevate Your Assessments?
        </h1>

        <button
          onClick={loginHandler}
          className="flex items-center gap-3 px-8 py-3 rounded-xl text-white font-semibold 
          bg-gradient-to-l from-indigo-950 to-indigo-800 hover:scale-105 transition"
        >
          <span>Get Started Free</span>
          <FaArrowRight />
        </button>

      </div>
    </div>
  </section>

  <TermsAndPolicyFooter />

  {showDemoModal && (
    <BookDemoModal onClose={() => setShowDemoModal(false)} />
  )}
</>


</div>
);
}

export default LandingPage;